export default __webpack_public_path__ + "static/media/looplogo.e3d82f0e.svg";